var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//@TODO: Move to shared/ui and deprecate exisitng Button/LinkButton
import classNames from "classnames";
import { computeThemeClassNames } from "../utils/utils";
import { Spinner } from "../../../ui/loading/spinner/spinner";
import styles from "./button.module.css";
export var ThemedButtonStyles = styles;
export var rootButtonClassNames = function (_a) {
    var _b;
    var inline = _a.inline, _c = _a.inlineMobile, inlineMobile = _c === void 0 ? inline : _c, blockMobile = _a.blockMobile, text = _a.text, stretchShield = _a.stretchShield;
    return classNames(styles["root"], (_b = {},
        _b[styles["inline"]] = !!inline,
        _b[styles["inline-mobile"]] = !!inlineMobile,
        _b[styles["block-mobile"]] = !!blockMobile,
        _b[styles["stretch-shield"]] = !!stretchShield,
        _b));
};
export var DEFAULT_BUTTON_LOADING = _jsx(Spinner, {});
export function ThemedButton(_a) {
    var _b, _c, _d;
    var _e = _a.className, className = _e === void 0 ? "" : _e, _f = _a.innerClassName, innerClassName = _f === void 0 ? "" : _f, _g = _a.contentClassName, contentClassName = _g === void 0 ? "" : _g, children = _a.children, _h = _a.theme, theme = _h === void 0 ? "primary" : _h, darkTheme = _a.darkTheme, _j = _a.size, size = _j === void 0 ? "md" : _j, outline = _a.outline, _k = _a.filled, filled = _k === void 0 ? !outline : _k, text = _a.text, _l = _a.capsule, capsule = _l === void 0 ? size === "lg" || !!text : _l, inline = _a.inline, _m = _a.inlineMobile, inlineMobile = _m === void 0 ? inline : _m, blockMobile = _a.blockMobile, underline = _a.underline, bold = _a.bold, stretchShield = _a.stretchShield, loading = _a.loading, disabled = _a.disabled, _o = _a.loader, loader = _o === void 0 ? DEFAULT_BUTTON_LOADING : _o, icon = _a.icon, _p = _a.alignIcon, alignIcon = _p === void 0 ? "end" : _p, raiseIcon = _a.raiseIcon, _q = _a.raiseIconTheme, raiseIconTheme = _q === void 0 ? theme : _q, _r = _a.primaryIcon, primaryIcon = _r === void 0 ? icon : _r, primaryIconTheme = _a.primaryIconTheme, _s = _a.alignPrimaryIcon, alignPrimaryIcon = _s === void 0 ? alignIcon : _s, _t = _a.raisePrimaryIcon, raisePrimaryIcon = _t === void 0 ? raiseIcon : _t, raisePrimaryIconTheme = _a.raisePrimaryIconTheme, secondaryIcon = _a.secondaryIcon, secondaryIconTheme = _a.secondaryIconTheme, _u = _a.alignSecondaryIcon, alignSecondaryIcon = _u === void 0 ? "start" : _u, raiseSecondaryIcon = _a.raiseSecondaryIcon, raiseSecondaryIconTheme = _a.raiseSecondaryIconTheme, _v = _a.pseudoBackground, pseudoBackground = _v === void 0 ? true : _v, rest = __rest(_a, ["className", "innerClassName", "contentClassName", "children", "theme", "darkTheme", "size", "outline", "filled", "text", "capsule", "inline", "inlineMobile", "blockMobile", "underline", "bold", "stretchShield", "loading", "disabled", "loader", "icon", "alignIcon", "raiseIcon", "raiseIconTheme", "primaryIcon", "primaryIconTheme", "alignPrimaryIcon", "raisePrimaryIcon", "raisePrimaryIconTheme", "secondaryIcon", "secondaryIconTheme", "alignSecondaryIcon", "raiseSecondaryIcon", "raiseSecondaryIconTheme", "pseudoBackground"]);
    theme = disabled ? "dark-grey" : theme;
    darkTheme = disabled ? "dark-grey" : darkTheme;
    return (_jsxs("div", { className: classNames(styles["container"], className, computeThemeClassNames(text || (outline && !disabled)
            ? {
                text: text && inline
                    ? theme
                    : theme === "alert"
                        ? "red"
                        : undefined,
                border: theme,
                pseudoBackground: pseudoBackground,
            }
            : __assign(__assign({}, rest), { background: theme, border: theme, pseudoBackground: pseudoBackground, hover: true, dark: darkTheme
                    ? {
                        background: darkTheme,
                    }
                    : undefined })), (_b = {},
            _b[styles["has-icons"]] = !!primaryIcon || !!secondaryIcon,
            _b[styles["has-primary-icon"]] = !!primaryIcon,
            _b[styles["has-raised-primary-icon"]] = !!raisePrimaryIcon,
            _b[styles["has-secondary-icon"]] = !!secondaryIcon,
            _b[styles["has-raised-secondary-icon"]] = !!raiseSecondaryIcon,
            _b[styles["outline"]] = disabled ? true : !!outline,
            _b[styles["filled"]] = !!filled,
            _b[styles["inline"]] = !!inline,
            _b[styles["inline-mobile"]] = !!inlineMobile,
            _b[styles["block-mobile"]] = !!blockMobile,
            _b[styles["text"]] = !!text,
            _b[styles["bold"]] = !!bold,
            _b[styles["disabled"]] = !!disabled,
            _b[styles["capsule"]] = !!capsule,
            _b[styles["loading"]] = !!loading,
            _b[styles["underline"]] = !!text && !!underline,
            _b[styles[size]] = !!size,
            _b)), children: [_jsxs("div", { className: classNames(styles["inner"], innerClassName), children: [!!primaryIcon && (_jsx("div", { className: classNames(styles["primary"], styles["icon"], (_c = {},
                            _c[styles["align-".concat(alignPrimaryIcon)]] = !!alignPrimaryIcon,
                            _c[styles["raised"]] = !!raisePrimaryIcon,
                            _c), computeThemeClassNames(raisePrimaryIcon
                            ? {
                                background: raisePrimaryIconTheme,
                                variant: true,
                            }
                            : primaryIconTheme
                                ? {
                                    text: primaryIconTheme,
                                }
                                : {})), children: primaryIcon })), _jsx("div", { className: styles["content"], children: children }), !!secondaryIcon && (_jsx("div", { className: classNames(styles["secondary"], styles["icon"], (_d = {},
                            _d[styles["align-".concat(alignSecondaryIcon)]] = !!alignSecondaryIcon,
                            _d[styles["raised"]] = !!raiseSecondaryIcon,
                            _d), computeThemeClassNames(raiseSecondaryIcon
                            ? {
                                background: raiseSecondaryIconTheme,
                                variant: true,
                            }
                            : secondaryIconTheme
                                ? {
                                    text: secondaryIconTheme,
                                }
                                : {})), children: secondaryIcon }))] }), !!loading && !!loader && (_jsx("div", { className: styles["loader"], children: loader }))] }));
}
